import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { badgeVerificationQueueParams } from "../../../admin-api/finance";
import { adminApi } from "../../../api-client";
import type { BadgeStatus } from "../../../schemas/finance/badge";
import { queryKeys } from "../../query-keys";

export function useBadgeVerificationQueue(status?: BadgeStatus) {
	const params = { ...badgeVerificationQueueParams(), ...(status ? { status } : {}) };
	return useQuery({
		queryFn: () => adminApi.finance.badges.list(params),
		queryKey: queryKeys.badges.verificationQueue(params.status),
	});
}

export function useApproveBadge() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (badgeId: string) => adminApi.finance.badges.approve(badgeId),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: queryKeys.badges.verificationQueue(),
			});
		},
	});
}

export function useRejectBadge() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ badgeId, reason }: { badgeId: string; reason?: string }) =>
			adminApi.finance.badges.reject(badgeId, reason),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: queryKeys.badges.verificationQueue(),
			});
		},
	});
}
